import type { CfAllocationMode } from "@/modules/cf-feed/domain/lib/cf-allocation-mode";

export type ProductAllocationDraft = {
  allocationMode: CfAllocationMode;
  allocatedQuantity?: number;
};
export type ProductAllocationInput = {
  allocationMode: CfAllocationMode;
  allocatedQuantity?: number;
};

/** แปลงโหมดและจำนวนสูงสุดที่เปิดขายเฉพาะ Feed/Live */
export function parseProductAllocation(
  draft: ProductAllocationDraft,
): ProductAllocationInput {
  if (draft.allocationMode !== "limit" && draft.allocationMode !== "unlimited")
    throw new Error("INVALID_ALLOCATION_MODE");
  if (draft.allocationMode === "unlimited")
    return { allocationMode: "unlimited" };
  if (
    draft.allocatedQuantity == null ||
    !Number.isInteger(draft.allocatedQuantity) ||
    draft.allocatedQuantity < 1
  )
    throw new Error("INVALID_QUANTITY");
  return {
    allocationMode: "limit",
    allocatedQuantity: draft.allocatedQuantity,
  };
}

export function productAllocationError(
  draft: ProductAllocationDraft,
): string | null {
  try {
    parseProductAllocation(draft);
    return null;
  } catch {
    return "INVALID_ALLOCATION_MODE";
  }
}
